// Generic zone map controller for displaying polygons on Google Maps
// Used by both airport zones and landowner zones
// For google maps api
import { Controller } from "@hotwired/stimulus"
import * as myMap from "./maps";
import {defaultMapOptions, resolveMapTypeId, layerManager} from "./maps";
import { stopLinkBeingFollowed } from "./maps";

// the map is stored in a global (this.map)
export default class extends Controller {
  static targets = ['map', 'zone']

  // draw polygon and return it
  drawPolygonFromJson(map, json_path, colour = 'red', weight = 1.5, opacity = 0) {
    return new google.maps.Polygon({
      paths: json_path,
      strokeWeight: weight,
      fillOpacity: opacity,
      strokeColor: colour,
      clickable: true, // need this to respond to mouseover events
      map: map
    });
  }

  // Use centralized toggle method
  async toggleLayer(event) {
    await layerManager.handleToggleLayer(event);
  }

  async resetMap(event) {
    stopLinkBeingFollowed(event);
    let mapCentreLat = this.data.get("mapCentreLat");
    let mapCentreLon = this.data.get("mapCentreLon");
    const zoom = parseInt(this.data.get("defaultZoom")) || 12;
    const mapType = resolveMapTypeId(this.data.get("defaultMapType"));
    this.map.setOptions(defaultMapOptions(mapCentreLat, mapCentreLon, zoom, mapType));
    await layerManager.resetAllLayerDefaults(this.element, 'airport-zone-map');
  }

  async connect() {
    // console.log('airport zone map controller');

    let mapCentreLat = this.data.get("mapCentreLat");
    let mapCentreLon = this.data.get("mapCentreLon");
    const zoom = parseInt(this.data.get("defaultZoom")) || 12;
    const mapType = resolveMapTypeId(this.data.get("defaultMapType"));

    let map = new google.maps.Map(this.mapTarget, myMap.defaultMapOptions(mapCentreLat, mapCentreLon, zoom, mapType));
    this.map = map;

    // Initialize layers (restricted airspace, etc.)
    await layerManager.initializeLayers(this.map, this);

    let _this = this
    for (let zone of this.zoneTargets) {
      const coords = JSON.parse(zone.innerHTML);
      if (coords !== null) {
        _this.drawPolygonFromJson(map, coords);
      }
    }
  }

}
